import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ContentBody from "./ContentBody";

export default function Content() {
  const { pageKey } = useParams() ?? "404";
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/${pageKey}`)
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error(`Error loading ${pageKey} content`, err));
  }, [pageKey]);

  if (!data) return null;

  return (
    <div className="pane pane-center">
      <h1>{data.title}</h1>
      <ContentBody data={data} />
    </div>
  );
}
